import { create } from "zustand";
import {
  type AmbientOcclusionTuning,
  DEFAULT_AMBIENT_OCCLUSION_TUNING,
} from "../new/ambientOcclusionSettings";

/**
 * Live ambient occlusion settings for the development tuning panel.
 *
 * The panel renders as DOM, outside the R3F canvas, so it cannot reach the
 * pass instance directly — this store is what connects the two. Nothing reads
 * it unless a viewer was mounted with ambient occlusion diagnostics on, so the
 * production path keeps the committed constants.
 *
 * There used to be an `implementation` here as well, selecting between two
 * passes and re-seeding the dials from the chosen one's own defaults. There is
 * one pass now, and one set of defaults.
 */
interface AmbientOcclusionTuningState {
  tuning: AmbientOcclusionTuning;
  setTuning: (tuning: Partial<AmbientOcclusionTuning>) => void;
  /** Restore the committed defaults. */
  reset: () => void;
}

export const useAmbientOcclusionTuning = create<AmbientOcclusionTuningState>(
  (set) => ({
    tuning: { ...DEFAULT_AMBIENT_OCCLUSION_TUNING },
    setTuning: (tuning) => {
      set((state) => ({ tuning: { ...state.tuning, ...tuning } }));
    },
    reset: () => {
      set({ tuning: { ...DEFAULT_AMBIENT_OCCLUSION_TUNING } });
    },
  }),
);
